import React, { useState, useEffect, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useQueries from '../../../database/useQueries';
import { useSelector } from 'react-redux';
import FormTemplate from '../../template/form/FormTemplate';
import { formatPriceIL, getFieldOptions } from '../plagins/data/commponentOptions';
import LoadingOverlay from '../pagesMains/LoadingOverlay';
import SignatureForm from '../plagins/signs/SignatureForm';
import { GlobalContext } from '../../../App';
import CustomDialog from '../plagins/dialogs/customDialog';
import PaymentsManagement from '../pagesCreate/paymentsManagementCreate';
import { DataContext, TemplateContext } from '../pagesMains/GravesManagers/Graves';
import { fullSelectedAreaGraves, fullSelectedBlocks, fullSelectedCemeteries, fullSelectedCustomers, fullSelectedGraves, fullSelectedPlots, fullSelectedRows } from '../plagins/data/multiSelectedForm';
import { format, parseISO } from 'date-fns'

// הגדרת שם הישות כקבוע
const NAME_ENTITY = 'רכישה';

function PurchaseUpdate({ propValue = null }) {
  // קבלת ערכים מהסטור
  const optionsFields = useSelector((state) => state.dataOptionsFieldsHe.data);
  const columns = useSelector((state) => state.columnsFormPurchases.data);

  const context = useContext(DataContext);

  const { permission, setTitle } = useContext(GlobalContext);
  const { setTotalWidthContainer } = useContext(TemplateContext);
  const myPermissions = [];

  // טעינת היוזים לפונקציות עזר
  const { getEntityByAttr, getEntitiesByAttr, addOrUpdateDataPurchase, AllDataSignatures } = useQueries();

  // ערכי הראוטר
  const location = useLocation();
  const navigate = useNavigate();
  const { value } = location.state || {};

  const [myPurchase, setMyPurchase] = useState(() => {
    const val = propValue !== null ? propValue : value;
    const foundItem = context?.contextPurchases?.find((item) => {
      // console.log('Comparing:', item?.unicId, 'with', val?.unicId);
      return item?.unicId === val?.unicId;
    });
    return foundItem || value;
  });

  setTotalWidthContainer(1200);
  setTitle(`עדכון רכישה`);

  // איזור המשתנים והסטייטים
  // משתנים לטופס
  const [fieldsWithDynamicDisabled, setFieldsWithDynamicDisabled] = useState([]); // השדות
  const [formValues, setFormValues] = useState({}); // ערכי השדות
  const [errors, setErrors] = useState({}); // שגיאת השדות
  // עוקב אחר שליחת נתונים לשרת דרך פונקציית סבמיט
  const [loadingData, setloadingData] = useState(false);

  // משתנים לערכי סלקט של השדות
  const [cemeteries, setCemeteries] = useState([]);
  const [blocks, setBlocks] = useState([]);
  const [plots, setPlots] = useState([]);
  const [rows, setRows] = useState([]);
  const [areaGraves, setAreaGraves] = useState([]);
  const [graves, setGraves] = useState([]);
  const [clients, setClients] = useState([]);
  const [totalPrice, setTotalPrice] = useState(0);
  const [contacts, setContacts] = useState([]);
  const [openTest, setOpenTest] = useState(false);

  // שינוי תשלומים לפני שמירה
  const [tempPayments, setTempPayments] = useState([]);
  const [defaultPayments, setDefaultPayments] = useState([]);

  const [isFormOpen, setIsFormOpen] = useState(false);
  const [signatures, setSignatures] = useState([
    {
      signatureImage: null,
      signerName: 'מלכיאל בן עזרא מזכיר ח״ק',
      signerTitle: 'מלכיאל בן עזרא מזכיר ח״ק',
      permission: 1,
      status: 1,
      timestamp: null
    },
    {
      signatureImage: null,
      signerName: 'רבקה ג׳ורנו הנה״ח',
      signerTitle: 'רבקה ג׳ורנו הנה״ח',
      permission: 3,
      status: 1,
      timestamp: null
    }
  ]);

  // פונקציה לטעינת השדות מתוך הסטור
  const myColumns = (localColumns = null) => {
    localColumns = localColumns !== null ? localColumns : columns;
    const tempPermission = permission === 0 || myPermissions.includes(permission);
    return localColumns.map((field, index) => {
      let lock = false;
      lock = field.name === 'cemeteryId' || field.name === 'blockId' || field.name === 'plotId' || field.name === 'lineId' || field.name === 'areaGraveId' || field.name === 'graveId' || field.name === 'clientId' ? true : false;

      if (!tempPermission) {
        lock = field.name === 'BookkeepingApproval' ? true : false;
      }

      return {
        ...field,
        disabled: false,
        // disabled: lock ? lock : field.disabled,
        // disabled: !(permission === 0 || field?.updatePermissions?.includes(permission)),
        required: field.name === 'spouse' && formValues.maritalStatus === 2 ? true : field.required || false,
        show: field?.show || false
      };
    });
  };

  // פעולות המתבצעות רק לאחר קבלת דאטה בייס ווליו מהראוטר
  useEffect(() => {
    handleAllDataLoaded();
  }, [context]);

  // טעינת הנתונים לאחר קבלת הערכים מהדאטה בייס הלוקלי
  const handleAllDataLoaded = () => {
    setFieldsWithDynamicDisabled(myColumns());

    if (myPurchase?.unicId) {
      const grave = getEntityByAttr(context?.contextGraves, 'unicId', myPurchase?.graveId);
      let mySignatures = getEntitiesByAttr(context?.contextSignatures, 'hashPurchase', myPurchase?.unicId);
      if (mySignatures?.length === 0) {
        mySignatures = [
          {
            signatureImage: null,
            signerName: 'מלכיאל בן עזרא מזכיר ח״ק',
            signerTitle: 'מלכיאל בן עזרא מזכיר ח״ק',
            permission: 1,
            status: 1,
            timestamp: null
          },
          {
            signatureImage: null,
            signerName: 'רבקה ג׳ורנו הנה״ח',
            signerTitle: 'רבקה ג׳ורנו הנה״ח',
            permission: 3,
            status: 1,
            timestamp: null
          }
        ];
      }

      const processSignatures = async (signatures) => {
        const updatedSignatures = await Promise.all(
          signatures?.map(async (item) => {
            return {
              ...item
            };
          })
        );

        return updatedSignatures;
      };

      let initialFormValues = myColumns()
        .filter((field) => field?.name)
        .reduce(
          (acc, field) => {
            let fieldValue = myPurchase[field.name] || '';
            if (field.name === 'price') {
              fieldValue = formatPriceIL(myPurchase[field.name]);
            }
            if (field.input === 'date') {
              try {
                const date = parseISO(fieldValue);
                fieldValue = format(date, 'yyyy-MM-dd');
              } catch (error) {
                fieldValue = ''; // ערך לא תקין, אפשר להחזיר ערך ריק או מה שמתאים לך
              }
            }
            return {
              ...acc,
              [field.name]: fieldValue
            };
          },
          {
            id: myPurchase?.unicId,
            unicId: myPurchase?.unicId
          }
        );

      processSignatures(mySignatures).then((updatedSignatures) => {
        setSignatures(updatedSignatures);
      });

      initialFormValues = { ...initialFormValues, areaGraveId: grave?.areaGraveId, lineId: grave?.lineId, plotId: grave?.plotId };

      fieldAuto(grave, myPurchase);

      setFormValues((prev) => {
        const updatedValues = { ...initialFormValues }; // העתקת initialFormValues כבסיס
        Object.keys(prev).forEach((key) => {
          if (prev[key] !== undefined && prev[key] !== null) {
            updatedValues[key] = prev[key]; // שמירה על הערכים הקיימים ב-prev
          }
        });
        return updatedValues;
      });
    }
  };

  // טעינת ערכים אוטומטית לשדות
  const fieldAuto = (grave, purchase) => {
    setCemeteries(fullSelectedCemeteries(context?.contextCemeteries));
    setBlocks(fullSelectedBlocks(getEntitiesByAttr(context?.contextBlocks, 'unicId', grave?.blockId)));
    setPlots(fullSelectedPlots(getEntitiesByAttr(context?.contextPlots, 'unicId', grave?.plotId)));
    setRows(fullSelectedRows(getEntitiesByAttr(context?.contextRows, 'unicId', grave?.lineId)));
    setAreaGraves(fullSelectedAreaGraves(getEntitiesByAttr(context?.contextAreaGraves, 'unicId', grave?.areaGraveId)));
    setGraves(fullSelectedGraves(getEntitiesByAttr(context?.contextGraves, 'unicId', grave?.unicId)));
    setClients(fullSelectedCustomers(context?.contextCustomers?.filter((cust) => cust?.statusCustomer !== 2 || (cust?.statusCustomer === 2 && cust?.unicId === purchase?.clientId))));
    setContacts(fullSelectedCustomers(context?.contextCustomers));

    setTotalPrice(purchase?.price);
    setDefaultPayments(
      typeof purchase?.paymentsList === 'string'
        ? JSON.parse(purchase?.paymentsList)
        : // אם זה כבר מערך - השאר אותו כמו שהוא
        Array.isArray(purchase?.paymentsList)
        ? purchase?.paymentsList
        : []
    );
  };

  //לוגיקת הזנה ב cemetery
  const fieldChangeCemeteryId = (event, newFormValues) => {
    delete newFormValues?.blockId;
    delete newFormValues?.plotId;
    delete newFormValues?.lineId;
    delete newFormValues?.areaGraveId;
    delete newFormValues?.graveId;
    delete newFormValues?.areaGraveNameHe;
    delete newFormValues?.graveType;

    let blocks = getEntitiesByAttr(context?.contextBlocks, event.target.name, event.target.value);
    let plots = [];
    blocks.forEach((block) => {
      let tempPlots = getEntitiesByAttr(context?.contextPlots, 'blockId', block?.unicId);
      plots = plots.concat(tempPlots);
    });
    let rows = [];
    let areaGraves = [];
    let graves = [];

    return {
      blocks,
      plots,
      rows,
      areaGraves,
      graves
    };
  };
  //לוגיקת הזנה ב block
  const fieldChangeBlockId = (event, newFormValues) => {
    delete newFormValues?.plotId;
    delete newFormValues?.lineId;
    delete newFormValues?.areaGraveId;
    delete newFormValues?.graveId;
    delete newFormValues?.areaGraveNameHe;
    delete newFormValues?.graveType;

    const block = getEntityByAttr(context?.contextBlocks, 'unicId', event.target.value);
    const cemeteryId = getEntityByAttr(context?.contextCemeteries, 'unicId', block?.cemeteryId)?.unicId;

    newFormValues = { ...newFormValues, cemeteryId };

    let plots = getEntitiesByAttr(context?.contextPlots, event.target.name, event.target.value);
    let rows = [];
    let areaGraves = [];
    let graves = [];

    return {
      newFormValues,
      plots,
      rows,
      areaGraves,
      graves
    };
  };
  //לוגיקת הזנה ב plot
  const fieldChangePlotId = (event, newFormValues) => {
    delete newFormValues?.lineId;
    delete newFormValues?.areaGraveId;
    delete newFormValues?.graveId;
    delete newFormValues?.areaGraveNameHe;
    delete newFormValues?.graveType;

    const plot = getEntityByAttr(context?.contextPlots, 'unicId', event.target.value);
    const block = getEntityByAttr(context?.contextBlocks, 'unicId', plot?.blockId);
    const blockId = block?.unicId;
    const cemeteryId = getEntityByAttr(context?.contextCemeteries, 'unicId', block?.cemeteryId)?.unicId;

    newFormValues = { ...newFormValues, cemeteryId, blockId };

    let rows = getEntitiesByAttr(context?.contextRows, event.target.name, event.target.value);
    let areaGraves = getEntitiesByAttr(context?.contextAreaGraves, event.target.name, event.target.value);
    let graves = [];

    return {
      newFormValues,
      rows,
      areaGraves,
      graves
    };
  };
  //לוגיקת הזנה ב row
  const fieldChangeLineId = (event, newFormValues) => {
    delete newFormValues?.areaGraveId;
    delete newFormValues?.graveId;
    delete newFormValues?.areaGraveNameHe;
    delete newFormValues?.graveType;

    const row = getEntityByAttr(context?.contextRows, 'unicId', event.target.value);
    const plot = getEntityByAttr(context?.contextPlots, 'unicId', row?.plotId);
    const block = getEntityByAttr(context?.contextBlocks, 'unicId', plot?.blockId);

    const cemeteryId = getEntityByAttr(context?.contextCemeteries, 'unicId', block?.cemeteryId)?.unicId;
    const blockId = block?.unicId;
    const plotId = plot?.unicId;

    newFormValues = { ...newFormValues, cemeteryId, blockId, plotId };

    let areaGraves = getEntitiesByAttr(context?.contextAreaGraves, event.target.name, event.target.value);
    let graves = [];

    return {
      newFormValues,
      areaGraves,
      graves
    };
  };
  //לוגיקת הזנה ב area grave
  const fieldChangeAreaGraveId = (event, newFormValues) => {
    delete newFormValues?.graveId;
    delete newFormValues?.areaGraveNameHe;
    delete newFormValues?.graveType;

    const areaGrave = getEntityByAttr(context?.contextAreaGraves, 'unicId', event.target.value);
    const line = getEntityByAttr(context?.contextRows, 'unicId', areaGrave?.lineId);
    const plot = getEntityByAttr(context?.contextPlots, 'unicId', line?.plotId);
    const block = getEntityByAttr(context?.contextBlocks, 'unicId', plot?.blockId);

    const cemeteryId = getEntityByAttr(context?.contextCemeteries, 'unicId', block?.cemeteryId)?.unicId;
    const blockId = block?.unicId;
    const plotId = plot?.unicId;
    const lineId = line?.unicId;

    newFormValues = { ...newFormValues, cemeteryId, blockId, plotId, lineId };

    let graves = getEntitiesByAttr(context?.contextGraves, event.target.name, areaGrave?.gravesList);

    return {
      newFormValues,
      graves
    };
  };
  //לוגיקת הזנה בשדות הטופס
  const handleChange = (event) => {
    if (event.target.name === 'paymentsList') {
      setOpenTest(true);
      return;
    }
    let newFormValues = { ...formValues };
    if (event.target.name === 'cemeteryId') {
      let res = fieldChangeCemeteryId(event, newFormValues);
      setBlocks(res?.blocks);
      setPlots(res?.plots);
      setRows(res?.rows);
      setAreaGraves(res?.areaGraves);
      setGraves(res?.graves);
    }
    if (event?.target?.name === 'blockId') {
      let res = fieldChangeBlockId(event, newFormValues);
      setPlots(res?.plots);
      setRows(res?.rows);
      setAreaGraves(res?.areaGraves);
      setGraves(res?.graves);
      newFormValues = res?.newFormValues;
    }
    if (event?.target?.name === 'plotId') {
      let res = fieldChangePlotId(event, newFormValues);
      setRows(res?.rows);
      setAreaGraves(res?.areaGraves);
      setGraves(res?.graves);
      newFormValues = res?.newFormValues;
    }
    if (event?.target?.name === 'lineId') {
      let res = fieldChangeLineId(event, newFormValues);
      setAreaGraves(res?.areaGraves);
      setGraves(res?.graves);
      newFormValues = res?.newFormValues;
    }
    if (event?.target?.name === 'areaGraveId') {
      let res = fieldChangeAreaGraveId(event, newFormValues);
      setGraves(res?.graves);
      newFormValues = res?.newFormValues;
    }

    // setFormValues({ ...newFormValues, [event.target.name]: event.target.value });

    setFormValues((prev) => {
      return { ...prev, ...newFormValues, [event.target.name]: event.target.value };
    });
  };
  // אימות ערכים
  const validateForm = () => {
    let tempErrors = {};
    let formIsValid = true;

    columns.forEach((field) => {
      if (field.required && !formValues[field.name]) {
        tempErrors[field.name] = 'שדה חובה';
        formIsValid = false;
      }
      if (field.notRepeat && formValues[field.name]) {
        if (plots.some((item) => item[field.name] === formValues[field.name])) {
          tempErrors[field.name] = `הערך ${formValues[field.name]} כבר קיים`;
          formIsValid = false;
        }
      }
    });

    setErrors(tempErrors);
    return formIsValid;
  };
  // שליחת הטופס
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateForm()) {
      handleOpenForm();
    }
  };
  const handleOpenForm = () => {
    setIsFormOpen(true);
  };

  const handleCloseForm = () => {
    setIsFormOpen(false);
  };

  const handleFormSubmit = (submittedSignatures) => {
    setloadingData(true);

    let newFormValues = { ...formValues, price: totalPrice, paymentsList: formValues?.paymentsList };
    delete newFormValues?.cemeteryId;
    delete newFormValues?.blockId;
    delete newFormValues?.plotId;
    delete newFormValues?.lineId;
    delete newFormValues?.areaGraveId;

    async function executeQueries(newFormValues) {
      try {
        setloadingData(true);

        // הוספת נתוני הקבר, הלקוח, והחתימות למבנה הנתונים שנשלח לשרת
        const requestData = {
          ...newFormValues,
          signatures: submittedSignatures.map((element) => ({
            ...element,
            hashPurchase: newFormValues.hashPurchase
          }))
        };

        // שליחת הנתונים לשרת בפנייה אחת
        let res = await addOrUpdateDataPurchase(requestData);

        // בדיקת התוצאה
        if (res === 200) {
          // פעולות לאחר הצלחה
          setloadingData(false);
          AllDataSignatures();
          navigate(-1);
        } else {
          // טיפול במקרה של כישלון
          console.error('השאילתה נכשלה');
          setloadingData(false);
        }
      } catch (error) {
        console.error('שגיאה בביצוע השאילתות:', error);
        setloadingData(false);
      }
    }

    executeQueries(newFormValues);
  };

  const handlePaymentsChange = (payments) => {
    setTempPayments(payments);
  };

  const handleAnswerOk = (answer) => {
    if (answer) {
      let newFormValues = { ...formValues };
      let totalPrice = 0;

      tempPayments.forEach((pay) => {
        totalPrice += parseInt(pay.paymentAmount);
      });

      setDefaultPayments(tempPayments);
      setTotalPrice(totalPrice);

      console.log(12,formatPriceIL(totalPrice));
      

      newFormValues = { ...newFormValues, price: formatPriceIL(totalPrice), paymentsList: JSON.stringify(tempPayments) };

      // setFormValues(newFormValues);
      setFormValues((prev) => {
        return { ...prev, ...newFormValues };
      });
    }
    setOpenTest(false);
  };

  if (loadingData) return <LoadingOverlay />;

  return (
    <>
      <FormTemplate
        title={`עריכת ${NAME_ENTITY}`}
        btn={`עדכן`}
        fields={fieldsWithDynamicDisabled}
        columns={columns}
        formValues={{ ...formValues }}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
        errors={errors}
        options={{
          cemeteryId: cemeteries,
          blockId: blocks,
          plotId: plots,
          lineId: rows,
          areaGraveId: areaGraves,
          graveId: graves,
          clientId: clients,
          contactId: contacts,
          paymentsList: defaultPayments,
          BookkeepingApproval: getFieldOptions('BookkeepingApproval', optionsFields),
          buyerStatus: getFieldOptions('buyerStatus', optionsFields),
          purchaseStatus: getFieldOptions('purchaseStatus', optionsFields),
          isFuneralPayments: getFieldOptions('isFuneralPayments', optionsFields),
          diesSpouse: getFieldOptions('diesSpouse', optionsFields),
          numOfPayments: getFieldOptions('numOfPayments', optionsFields)
        }}
      />

      <SignatureForm open={isFormOpen} onClose={handleCloseForm} onSubmit={handleFormSubmit} signatures={signatures} setSignatures={setSignatures} />
      <CustomDialog open={openTest} handleClose={() => setOpenTest(false)} title={'ניהול תשלומים'} onOk={true} onCancel={true} no="ביטול" yes="אישור" onAnswer={handleAnswerOk} width={{ minWidth: '400px', maxWidth: '80%' }}>
        <PaymentsManagement defaultPayments={defaultPayments} onPaymentsChange={handlePaymentsChange} />
      </CustomDialog>
      <p>
        <span style={{ fontFamily: "'Courier New', Courier, monospace" }}>עדכון רכישה</span>
      </p>
    </>
  );
}

export default PurchaseUpdate;
